import React from "react";
import {
  Dialog,
  AppBar,
  makeStyles,
  Toolbar,
  Typography,
  Button,
} from "@material-ui/core";
import PropTypes from "prop-types";
import { text } from '../../utils/Multilanguage'

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
    backgroundColor: "#808080",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

export default function CustomDialog(props) {
  const {
    isOpen,
    handleClose,
    title,
    childrenElement,
    showCancelButton = false,
  } = props;
  const classes = useStyles();

  return (
    <Dialog fullScreen open={isOpen} onClose={handleClose}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Typography variant='h6' className={classes.title}>
            {title}
          </Typography>
          {showCancelButton && (
            <Button color='inherit' onClick={handleClose}>
              {text("Cancel")}
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <div style={{ height: "100%", width: "100%" }}>{childrenElement}</div>
    </Dialog>
  );
}

CustomDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  childrenElement: PropTypes.element.isRequired,
  showCancelButton: PropTypes.bool,
};
